import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getPartnerById } from '../../../../manage-player/api/services'
import { PartnerQueryKeys } from '@/modules/manage-player/keys'
import { GetPartnerByIdResponse } from '@/modules/manage-player/type'

export default function useQueryGetPartnerById(
	id: string,
	props?: UseBaseQueryOptions<GetPartnerByIdResponse>,
) {
	return useQuery({
		queryKey: [PartnerQueryKeys.GetPartnerById, id],
		queryFn: () => getPartnerById(id),
		...props,
	})
}
